import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10 mb-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Revisão:", -1)
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Fábrica:", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Básico:", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Intermediário:", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Recomendado:", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Código Extra:", -1)
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Fábrica:", -1)
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Básico:", -1)
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Intermediário:", -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Recomendado:", -1)
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Código Extra:", -1)
const _hoisted_37 = { class: "d-flex justify-content-end" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Incluir ", -1)
const _hoisted_39 = [
  _hoisted_38
]

import { reactive, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import { RevisionItemDetailView } from "@/models/CardapioModel";
import { updateRevision } from "@/services/CardapioService";
import { usePackage } from "@/pinia/cardapio/package/usePackage";
import { FormRules } from "element-plus";
import Swal from "sweetalert2/dist/sweetalert2.js";

interface OptionPackage {
  label: string;
  value: string;
}

interface RulesForm {
  revison: string;
  codigoFabrica: string;
  codigoBasico: string;
  codigoIntermediario: string;
  codigoRecomendado: string;
  codigoExtra: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormRevision',
  props: {
    updateRevision: {}
  },
  setup(__props: any) {

const props = __props;

const ruleFormRef = ref();
const emitter = useEmitter();
const { showTimeAlert } = useAlert();
const store = useStore();
const disabledInput = ref(false);
const dialogFormVisible = ref(false);
const form = reactive<RulesForm>({
  revison: "",
  codigoFabrica: "",
  codigoBasico: "",
  codigoIntermediario: "",
  codigoRecomendado: "",
  codigoExtra: "",
});
const codConcessionaria = localStorage.getItem("filtroConcessionaria");
const loading = reactive({
  submit: false,
  optionDescription: false,
});
const storePackage = usePackage();
const optionPackage = ref<OptionPackage[]>([]);
const rules = reactive<FormRules<RulesForm>>({
  codigoBasico: [
    {
      required: true,
      message: "Por favor, escolha um pacote..",
      trigger: "blur",
    },
  ],
  codigoFabrica: [
    {
      required: true,
      message: "Por favor, insira o código do pacote.",
      trigger: "blur",
    },
  ],
  codigoIntermediario: [
    {
      required: true,
      message: "Por favor, escolha um pacote..",
      trigger: "blur",
    },
  ],
  codigoRecomendado: [
    {
      required: true,
      message: "Por favor, escolha um pacote..",
      trigger: "blur",
    },
  ],
  revison: [
    {
      required: true,
      message: "Por favor, selecione o nome da revisão.",
      trigger: "blur",
    },
  ],
});

onMounted(() => {
  optionPackage.value = storePackage.getPackage.reduce<
    { label: string; value: string }[]
  >((acc, { codPackage, name }) => {
    if (codPackage) {
      acc.push({
        value: codPackage,
        label: name,
      });
    }

    return acc;
  }, []);
});

watch(
  () => props.updateRevision,
  (newValue) => {
    if (newValue) {
      form.codigoBasico = newValue.codigoBasico;
      form.codigoExtra = newValue.codigoExtra;
      form.codigoFabrica = newValue.codigoFabrica;
      form.codigoIntermediario = newValue.codigoIntermediario;
      form.codigoRecomendado = newValue.codigoRecomendado;
      form.revison = newValue.revison;
    }
  },
  { deep: true, immediate: true }
);

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      Swal.fire({
        title: "Deseja fazer alterações na revisão?",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        text: "As alterações serão refletidas no app assim que forem salvas.",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          handleSubmit();
        } else if (result.isDenied) {
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

const handleSubmit = async () => {
  if (codConcessionaria && typeof codConcessionaria == "string") {
    const payload = {
      ...form,
      car: props.updateRevision.car,
      currentCodigoFabrica: props.updateRevision.codigoFabrica,
      currentRevison: props.updateRevision.revison,
      grupoExibicao: props.updateRevision.family,
      codConcessionaria: codConcessionaria,
    };

    loading.submit = true;
    disabledInput.value = true;

    await updateRevision(payload)
      .then((r) => {
        showTimeAlert(r.message);
        emitter.emit("update-family", {});
      })
      .catch(() => {
        showTimeAlert("Não foi possível completar a solicitação", "error");
      })
      .finally(() => {
        loading.submit = false;
        disabledInput.value = false;
      });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: form,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "auto",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_el_form_item, { prop: "revison" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: disabledInput.value,
                    modelValue: form.revison,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.revison) = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_form_item, { prop: "codigoFabrica" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: disabledInput.value,
                    modelValue: form.codigoFabrica,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.codigoFabrica) = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_form_item, { prop: "codigoBasico" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha um pacote",
                    modelValue: form.codigoBasico,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.codigoBasico) = $event)),
                    filterable: "",
                    disabled: disabledInput.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `${item.label}${item.value}`,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_form_item, { prop: "codigoIntermediario" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha um pacote",
                    modelValue: form.codigoIntermediario,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.codigoIntermediario) = $event)),
                    disabled: disabledInput.value,
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `${item.label}${item.value}`,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_el_form_item, { prop: "codigoRecomendado" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha um pacote",
                    modelValue: form.codigoRecomendado,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.codigoRecomendado) = $event)),
                    disabled: disabledInput.value,
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `${item.label}${item.value}`,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_el_form_item, { prop: "codigoExtra" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha um pacote",
                    modelValue: form.codigoExtra,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.codigoExtra) = $event)),
                    disabled: disabledInput.value,
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Sem pacote",
                        value: ""
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `${item.label}${item.value}`,
                          label: item.label,
                          disabled: disabledInput.value,
                          value: item.value
                        }, null, 8, ["label", "disabled", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (dialogFormVisible.value = true)),
              class: "btn btn-sm background_btn_1_opct link-white w-32"
            }, [
              _hoisted_18,
              _createTextVNode(" Incluir Pacote na Revisão ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm background_btn_1 text-white",
              id: "kt_button_1",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm(ruleFormRef.value))),
              disabled: loading.submit
            }, [
              (!loading.submit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" Salvar ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(" Aguarde... ")
                  ]))
            ], 8, _hoisted_19)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogFormVisible.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dialogFormVisible).value = $event)),
      title: "Incluir Pacote na Revisão",
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "label-width": "auto",
          rules: rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_el_form_item, { prop: "codigoFabrica" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: disabledInput.value,
                      modelValue: form.codigoFabrica,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.codigoFabrica) = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_el_form_item, { prop: "codigoBasico" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      placeholder: "Escolha um pacote",
                      modelValue: form.codigoBasico,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.codigoBasico) = $event)),
                      filterable: "",
                      disabled: disabledInput.value
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: `${item.label}${item.value}`,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_el_form_item, { prop: "codigoIntermediario" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      placeholder: "Escolha um pacote",
                      modelValue: form.codigoIntermediario,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.codigoIntermediario) = $event)),
                      disabled: disabledInput.value,
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: `${item.label}${item.value}`,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(_component_el_form_item, { prop: "codigoRecomendado" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      placeholder: "Escolha um pacote",
                      modelValue: form.codigoRecomendado,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.codigoRecomendado) = $event)),
                      disabled: disabledInput.value,
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: `${item.label}${item.value}`,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_el_form_item, { prop: "codigoExtra" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      placeholder: "Escolha um pacote",
                      modelValue: form.codigoExtra,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.codigoExtra) = $event)),
                      disabled: disabledInput.value,
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Sem pacote",
                          value: ""
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPackage.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: `${item.label}${item.value}`,
                            label: item.label,
                            disabled: disabledInput.value,
                            value: item.value
                          }, null, 8, ["label", "disabled", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (dialogFormVisible.value = false)),
            type: "button",
            class: "btn btn-sm background_btn_1 text-white"
          }, _hoisted_39)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})